import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { DialogFooter } from "../../../components/DialogFooter";
import { LoadingButton } from "../../../components/LoadingButton";

interface RemoveRoleBottomSheetProps {
  modalState: UseModalState;
  onRemoveRole: () => Promise<void>;
  isRemovingRole: boolean;
  roleName: string | undefined;
}

export function RemoveRoleBottomSheet(props: RemoveRoleBottomSheetProps) {
  const { modalState, onRemoveRole, isRemovingRole, roleName } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter
          orientation="vertical"
          onClose={() => {
            modalState.closeModal();
          }}
        >
          <LoadingButton
            fullWidth
            variant="destructive"
            size="large"
            isLoading={isRemovingRole}
            onClick={async () => {
              await onRemoveRole();
            }}
          >
            Remove role
          </LoadingButton>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="document-rejected"
        title="Remove this role?"
        description={
          <Stack sx={{ flexDirection: "column", gap: 5, paddingX: 5 }}>
            <Text variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              By removing this role, you won&apos;t be able to see open{" "}
              {roleName ? `${roleName} ` : ""}shifts. You can add this role back at any time.
            </Text>
          </Stack>
        }
      />
    </BottomSheet>
  );
}
